import type { AttendanceDayLike } from "./summary";

export interface LateSeriesPoint {
	date: string;
	lateMinutes: number;
}

/**
 * Kunlik kechikish seriyasi — kanvasdagi `.lcols` diagrammasi uchun.
 *
 * ⚠️⚠️ **Oynadagi HAR kun uchun nuqta chiqadi, qatori yo'q kun 0 bilan.**
 * Faqat mavjud qatorlarni chizish o'qni siqib yuborardi: 30 kunlik
 * oynadagi ikki kechikish QO'SHNI ustun bo'lib ko'rinib, o'quvchi «ikki
 * kun ketma-ket kechikkan» degan yolg'on xulosaga kelardi. Diagramma
 * vaqt o'qi bo'ylab chiziladi, hodisalar ro'yxati bo'ylab emas.
 *
 * ⚠️ Oynadan tashqaridagi qator TASHLAB YUBORILADI — natijaning tartibi
 * ham, uzunligi ham OYNANIKI.
 *
 * ⚠️ `utils/summary.ts` ga qo'shilmaydi — u fayl poydevorda muzlatilgan.
 */
export function toLateSeries(days: AttendanceDayLike[], oyna: string[]): LateSeriesPoint[] {
	const xarita = new Map(days.map((day) => [day.workDate, day.lateMinutes]));

	return oyna.map((date) => ({ date, lateMinutes: xarita.get(date) ?? 0 }));
}
